import Missing from 'fe-design-base/assets/illustrationsDuotone/Missing';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Avatar from 'fe-design-base/molecules/Avatar';

import { BaseRequestProps } from 'features/notifications/types';

import { timeAgoShort } from 'util/dateTime';

import { title } from './consts';

const BaseRequest = ({
  children,
  name,
  updatedAt,
  type,
  avatar,
}: BaseRequestProps) => (
  <Box bgcolor="mono0" p={32} column gap={8} bbw={2} bcolor="mono300">
    <Box row alignItemsCenter justifyContentSpaceBetween>
      <Text variant="eyebrow">{title[type]}</Text>
      <Text variant="eyebrow">{timeAgoShort(updatedAt)}</Text>
    </Box>
    <Box row gap={16} alignItemsCenter>
      {type === 'claim' && !avatar ? (
        <Missing />
      ) : (
        <Avatar image={avatar} size="large" />
      )}
      <Text variant="bodyBoldTight">{name}</Text>
    </Box>
    {children}
  </Box>
);

export default BaseRequest;
